import styled from 'react-emotion'
import DownloadIconButton from '../DownloadIcon'

export const Card = styled(`div`)`
  ${tw`w-full md:w-4/5 mx-auto my-20 bg-white rounded-8 text-center pl-20 pr-20 flex justify-between items-center`}
  box-shadow:  0 1px 2px 0 rgba(151, 160, 176, 0.44), 0 -1px 1px 0 rgba(151, 160, 176, 0.12);
  border-left:6px solid #00c8ff;

@media (min-width:992px){
  ${tw`my-0 mb-16`}
}
`

export const CardContainerLink = styled('div')`
@media(min-width:992px){
width:50%;
&:nth-child(2) {
 /* margin-left:150px */
  }
}
:hover{
${tw`no-underline	text-dark-blue-grey`}
};
`

export const InvestorsInfoContainer = styled('div')`
margin-bottom:100px;
${tw`flex flex-col flex-wrap`};
margin-top:100px;
width:100%;
@media (min-width:992px){
    display:flex;
flex-wrap: wrap;
    flex-direction:row;
    min-height: calc(100vh - 760px);
    justify-content:center;
    align-items: center;
  }
`

export const IconTextContainer = styled('div')`
${tw`flex items-end sm:py-20 md:py-25`}
`

export const CardIcon = styled('img')`
${tw`h-20 w-20 mr-6`}
object-fit:contain;
`

export const CardDuration = styled('div')`
  ${tw`m-0 sm:pl-0 md:px-4  leading-none font-roboto font-medium text-left text-dark-blue-grey text-base`};
  
  @media (max-width:767px){
    font-size:16px
  }
`

export const ButtonContainer = styled('a')`
  ${tw`flex flex-row justify-end cursor-pointer m-15`}
`
export const DownloadIcon = styled(DownloadIconButton)`
  width:16px;height:16px;
`